var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'card flex-col shadow-sm',
        !_vm.wideContent ? 'container-v-lg container-h-lg' : '',
        _vm.nested ? 'nested' : '',
        _vm.active ? 'active' : '',
        _vm.clickable ? 'clickable' : ''
    ],attrs:{"data-dusk":_vm.dataDusk},on:{"click":[function($event){return _vm.$emit('click', $event)},function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.$emit('on-self-click', $event)}]}},[_c('div',[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }